<lms-list
  [listId]="listId"
  [serviceProvider]="AdaCustomizationsService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header class="table-item" field="name" label="customizations.header.name"></lms-list-header>
    <lms-list-header
      class="table-item hide-on-med-and-down"
      field="clientName"
      label="customizations.header.clientName"
    ></lms-list-header>
    <lms-list-header
      class="table-item hide-on-med-and-down"
      field="defaultForClient"
      label="customizations.header.defaultForClient"
    ></lms-list-header>
    <lms-list-header
      class="table-item hide-on-med-and-down"
      field="defaultForLanguage"
      label="customizations.header.defaultForLanguage"
    ></lms-list-header>
    <lms-list-header
      class="table-item hide-on-med-and-down"
      field="numDocuments"
      label="customizations.header.numPackages"
    ></lms-list-header>
    <div class="table-item"></div>
  </div>
  <lms-customizations-list-row *ngFor="let customization of customizations" [customization]="customization">
    <gl-button
      icon
      icon-center="glicon-trash"
      (onClick)="delete(customization)"
      *lmsProfileGuard="'customizations.delete'"
      title="{{ 'actions.unregister' | translate }}"
      row-actions
    >
    </gl-button>
  </lms-customizations-list-row>
</lms-list>
